import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const LoginPage = lazy(() => import('../pages/auth/Login'));
const SignUpPage = lazy(() => import('../pages/auth/SignUp'));
const AdminDashboard = lazy(() => import('../pages/admin/AdminDashboard'));
const EventsPage = lazy(() => import('../pages/events/page'));
const LevelPage = lazy(() => import('../pages/level/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/signup',
    element: <SignUpPage />,
  },
  {
    path: '/admin',
    element: <AdminDashboard />,
  },
  {
    path: '/events',
    element: <EventsPage />,
  },
  {
    path: '/level',
    element: <LevelPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
